import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {MatMiniFabButton} from "@angular/material/button";
import {UnitEconomicsCalculationData} from "../../types/unit-economics-calculations.types";

@Component({
  selector: 'app-unit-economics-calculations-title',
  imports: [
    MatIcon,
    MatMiniFabButton
  ],
  templateUrl: './unit-economics-calculations-title.component.html',
  styleUrl: './unit-economics-calculations-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitEconomicsCalculationsTitleComponent {
  data = input.required<UnitEconomicsCalculationData>();
  isEditModeActive = input.required<boolean>();
  handleDelete = output<MouseEvent>();
}
